import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VCalendar from 'v-calendar';
import runtime from 'serviceworker-webpack-plugin/lib/runtime';
import App from './App.vue';
import router from './router/Router';
import store from './stores/MainStore';
import { createProvider } from './apollo';
import translations from './translations/translations';
import './services/AppService';
import './vuetify';

runtime.register();
Vue.use(VueI18n);

Vue.use(VCalendar, {
  componentPrefix: 'vc',
});

Vue.config.productionTip = false;

const i18n = new VueI18n({
  locale: 'lt',
  fallbackLocale: 'en',
  messages: translations,
  silentTranslationWarn: process.env.NODE_ENV === 'production',
});

new Vue({
  i18n,
  router,
  store,
  apolloProvider: createProvider(),
  render: h => h(App),
}).$mount('#app');
